import { User } from 'module/api/user/types';
import { UserFieldMetadata } from 'module/types/filter-field/field/filterable-field';
import { fromPairs } from 'lodash';
import { userOption } from '../field/user-option';

export const asUserMetaData = (users: User[]): UserFieldMetadata => {
  return {
    options: users.map(userOption),
    users: {
      by_user_id: fromPairs(users.map((x) => [x.userId, x])),
      user_ids: users.map((x) => x.userId),
    },
  };
};
